import { render, staticRenderFns } from "./PendingDataTable.vue?vue&type=template&id=7375bfa0"
import script from "./PendingDataTable.vue?vue&type=script&lang=js"
export * from "./PendingDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports